import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import { Router } from 'react-router-dom';
import history from './routing/history';
import './index.css';
import store from './redux/store';
import { Provider } from 'react-redux';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { createRoot } from 'react-dom/client';
import JavascriptTimeAgo from 'javascript-time-ago';
import en from 'javascript-time-ago/locale/en';
JavascriptTimeAgo.locale(en);

export const googleScript = document.createElement('script');

googleScript.src = `https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_GOOGLE_KEY}&v=weekly&loading=async&libraries=places`;
googleScript.async = true;
googleScript.loaded = false;
googleScript.addEventListener('load', () => {
	googleScript.loaded = true;
});
document.body.appendChild(googleScript);

export const loadGoogle = (callback) => {
	if (googleScript.loaded) {
		callback();
	} else {
		googleScript.addEventListener('load', () => {
			callback();
		});
	}
};

const root = createRoot(document.getElementById('root'));

root.render(
	<Provider store={store}>
		{/* share the history logoutUser pushes to, so its redirects re-render the routes */}
		<Router history={history}>
			<App />
		</Router>
	</Provider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
